export const AUTH_STORAGE_KEY = '@mini-crm/auth-session'

export const MOCK_USER = {
  id: 'mock-user-01',
  name: 'Pedro SDR',
  email: 'pedro@mini-crm.dev',
  role: 'admin' as const,
  avatarUrl: 'https://avatar.iran.liara.run/public/49',
}

export const MOCK_PASSWORD = '123456'
